<div class="numbering-container">
  <div class="numbering-header">
    <div>
      <h2><i class="fa-solid fa-hashtag"></i> Ticket Numbering</h2>
      <p class="numbering-sub">
        Each organization numbers its tickets independently, with its own prefix
        (e.g. <code>ACME-0042</code>). Numbers are assigned when a ticket is created and never change;
        changing the prefix here only affects tickets created from now on.
      </p>
    </div>
  </div>

  <div class="banner banner-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="banner banner-success" *ngIf="successMessage">{{ successMessage }}</div>

  <div class="numbering-loading" *ngIf="isLoading">Loading…</div>

  <div class="numbering-card" *ngIf="!isLoading">
    <div class="form-grid">
      <label>Ticket prefix
        <input type="text" class="prefix-input" [(ngModel)]="prefix" maxlength="20"
               placeholder="TKT" [class.invalid]="!prefixValid" />
      </label>
    </div>

    <p class="prefix-hint" [class.error]="!prefixValid">
      1–20 characters · letters, digits, hyphen only.
    </p>

    <div class="preview">
      New tickets will be numbered <strong>{{ previewLabel }}</strong>
    </div>

    <button class="btn-primary" (click)="savePrefix()"
            [disabled]="!prefixValid || isSaving">
      <i class="fa-solid fa-floppy-disk"></i> {{ isSaving ? 'Saving…' : 'Save prefix' }}
    </button>
  </div>
</div>
